import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col } from 'reactstrap';

import Application from '../Application';
import DesignLoading from './BracketDesignLoading';
import GeneralLoading from './GeneralLoading';
import SafetyBarrierLocation from './SafetyBarriers/SafetyBarrierLocation';
import RebarReinforcementActionType from './RebarReinforcementActionType';
import Accordion from '@components/Accordion';
import AccordionItem from '@components/Accordion/components/AccordionItem';
import { APP_TEXTS } from '@texts';
import DeadLoadAndWindLoad from './SafetyBarriers/DeadLoad/DeadLoadAndWindLoad';
import WoodConnectionLoads from './WoodConnectionLoads';

class Loads extends Component {

  render() {
    return (
      <Row>
        <Col sm="12">
          { this.renderChoice(this.props.type) }
        </Col>
      </Row>
    );
  }

  renderChoice(type) {
    switch(type) {
      case Application.types.GENERAL_CALCULATION:
        return (
          <GeneralLoading />
        );

      case Application.types.BRACKET_ATTACHMENT:
        return (
          <DesignLoading />
        );

      case Application.types.SAFETY_BARRIER:
        return (
          <Accordion 
            className="application__accordion" 
            appStatus={this.props.appStatus}
          
          >
            <AccordionItem 
              id="safety_barrier_location" 
              title={APP_TEXTS.SAFETY_BARRIERS_LOCATION.Content}
            >
              <SafetyBarrierLocation />
            </AccordionItem>
            
            <AccordionItem 
              id="load_category" 
              DEAD_WIND_LOAD_TITLE
              title={APP_TEXTS.DEAD_WIND_LOAD_TITLE.Content}
            >
                <DeadLoadAndWindLoad/>
            </AccordionItem>
          </Accordion>
        );

      case Application.types.REBAR_REINFORCEMENT:
        return (
          <RebarReinforcementActionType />
        );
      
      case Application.types.WOOD_CONNECTION:
        return (
          <WoodConnectionLoads />
        );

      default:
        return null;
    }
  }

}

const mapState = state => ({
  type: state.main.appType
});

export default connect(mapState)(Loads);



// WEBPACK FOOTER //
// ./src/views/Loads/index.js